import { render, staticRenderFns } from "./DashboardAnnouncements.vue?vue&type=template&id=6a16d7c9&scoped=true"
import script from "./DashboardAnnouncements.vue?vue&type=script&lang=js"
export * from "./DashboardAnnouncements.vue?vue&type=script&lang=js"
import style0 from "./DashboardAnnouncements.vue?vue&type=style&index=0&id=6a16d7c9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a16d7c9",
  null
  
)

export default component.exports